
import { Star, Clock, Book, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

interface ProfileHeaderProps {
  username: string;
  avatarUrl: string | null;
  creatorCategory: string | null;
  totalRecipes: number;
  totalLikes: number;
  lastRecipeDate?: string;
  subscriptionPrice: number;
  isSubscribed: boolean;
  currentUserId?: string;
  profileId: string;
  onSubscribe: () => void;
  loading?: boolean;
}

export const ProfileHeader = ({
  username,
  avatarUrl,
  creatorCategory,
  totalRecipes,
  totalLikes,
  lastRecipeDate,
  currentUserId,
  profileId,
  loading = false,
}: ProfileHeaderProps) => {
  const navigate = useNavigate();

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  return (
    <div className="flex items-center space-x-4 mb-8">
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt={username}
          className="w-20 h-20 rounded-full object-cover select-none"
          onContextMenu={handleContextMenu}
          draggable="false"
        />
      ) : (
        <div 
          className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center select-none"
          onContextMenu={handleContextMenu}
        >
          <span className="text-2xl text-gray-500">
            {username.charAt(0).toUpperCase()}
          </span>
        </div>
      )}
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-bold">{username}</h1>
          {creatorCategory && (
            <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">
              {creatorCategory}
            </span>
          )}
        </div>
        <div className="flex gap-4 mt-2">
          <div className="flex items-center gap-1">
            <Book className="w-4 h-4 hidden md:inline" />
            <span>{totalRecipes} recipes</span>
          </div>
          <div className="flex items-center gap-1">
            <Heart className="w-4 h-4 text-red-500 hidden md:inline" />
            <span>{totalLikes} likes</span>
          </div>
          {lastRecipeDate && (
            <div className="flex items-center gap-1">
              <Clock className="w-4 h-4 hidden md:inline" />
              <span>Last recipe: {format(new Date(lastRecipeDate), 'MMM d, yyyy')}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
